(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  // JavaScript code to initialize the map and store locator functionality
  // This is a placeholder; actual implementation will depend on the mapping service used (e.g., Google Maps, Mapbox)

  } catch(e) { console.error(e); }
})();
})();
